import { container } from "tsyringe";

// interface
import type { NavigationService } from "@/shared/libs/navigation/interface";

// service
import { register as registerClassDataFormatConverter } from "@/apps/services/registers";
import NavigationServiceImpl from "@/apps/services/router/NavigationServiceImpl";

const appsServices = () => {
    registerClassDataFormatConverter();
    container.register<NavigationService>("NavigationService", {
        useValue: new NavigationServiceImpl(),
    });
};

export default appsServices;
